export const accessTokenItem = 'atkn';
export const refreshTokenItem = 'rtkn';
export let AuthF2aOtpChannel = /*#__PURE__*/function (AuthF2aOtpChannel) {
  AuthF2aOtpChannel["PHONE"] = "phone";
  AuthF2aOtpChannel["EMAIL"] = "email";
  return AuthF2aOtpChannel;
}({});
export let AuthErrorCode = /*#__PURE__*/function (AuthErrorCode) {
  AuthErrorCode["CAPTCHA_ERROR"] = "CAPTCHA_ERROR";
  AuthErrorCode["GENERIC_ERROR"] = "GENERIC_ERROR";
  AuthErrorCode["BLOCK_USER_ERROR"] = "BLOCK_USER_ERROR";
  AuthErrorCode["USER_NOT_FOUND_ERROR"] = "USER_NOT_FOUND_ERROR";
  AuthErrorCode["NOT_AUTH_ERROR"] = "NOT_AUTH_ERROR";
  AuthErrorCode["NOT_DEVICE"] = "NOT_DEVICE";
  AuthErrorCode["USER_CHANGE_PWD_ERROR"] = "USER_CHANGE_PWD_ERROR";
  AuthErrorCode["REGEX_ERROR"] = "REGEX_ERROR";
  AuthErrorCode["PASSW_NOT_MATCH"] = "PASSW_NOT_MATCH";
  AuthErrorCode["PASSW_MATCH"] = "PASSW_MATCH";
  AuthErrorCode["REPEAT_EMPTY"] = "REPEAT_EMPTY";
  AuthErrorCode["NEW_EMPTY"] = "NEW_EMPTY";
  AuthErrorCode["LAST_EMPTY"] = "LAST_EMPTY";
  AuthErrorCode["JWT_ERROR"] = "JWT_ERROR";
  AuthErrorCode["EXPIRED_URL"] = "EXPIRED_URL";
  AuthErrorCode["DECRYPT_PARAMS"] = "DECRYPT_PARAMS";
  AuthErrorCode["F2A_SELECT"] = "F2A_SELECT";
  AuthErrorCode["F2A_SMS"] = "F2A_SMS";
  AuthErrorCode["F2A_EMAIL"] = "F2A_EMAIL";
  AuthErrorCode["F2A_NOT_CONFIG"] = "F2A_NOT_CONFIG";
  AuthErrorCode["F2A_PHONE_NOT_MATCH"] = "F2A_PHONE_NOT_MATCH";
  AuthErrorCode["F2A_EMAIL_NOT_MATCH"] = "F2A_EMAIL_NOT_MATCH";
  AuthErrorCode["F2A_OTP_BAN"] = "F2A_OTP_BAN";
  AuthErrorCode["F2A_OTP_INCORRECT"] = "F2A_OTP_INCORRECT";
  return AuthErrorCode;
}({}); // otp code is incorrect